module.exports = __webpack_public_path__ + "static/media/broadcast.4fcce7ad.svg";